import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Images
import Logo from '../../images/logo.png';
import footerBg from '../../images/background/footer.jpg';
import ptImg1 from '../../images/shap/wave-blue.png';
import ptImg2 from '../../images/shap/circle-dots.png';
import ptImg3 from '../../images/shap/plus-blue.png';
import ptImg4 from '../../images/shap/wave-blue.png';

// Social Images
import facebook from '../../images/social/facebook.png';
import linkedin from '../../images/social/linkedin.png';

import cofepris from '../../images/cofepris_logo.png';

class aboutSection extends Component{
	render(){
		return(
			<>
				
				<footer className="footer" style={{backgroundImage: "url("+footerBg+")"}}>
					<div className="footer-top">
						<div className="container">
							<div className="row">
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_info">
										<div className="footer-logo">
											<Link to="/"><img src={Logo} alt=""/></Link>
										</div>
										<div className="ft-contact">
											<p>Ofrecemos servicios de calidad que ayudan en gran medida a garantizar que se cumplan sus requisitos</p>
											<div className="contact-bx">
												<div className="icon"><i className="fas fa-phone-alt"></i></div>
												<div className="contact-number">
													<span>Contacto</span>
													<h4 className="number">449 266 9487</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget ml-50">
										<h3 className="footer-title">Enlaces Directos</h3>
										<ul>
											<li><Link to="/acerca-de"><span>Acerca de</span></Link></li>
											<li><Link to="/cobertura"><span>Cobertura</span></Link></li>
											<li><Link to="/service_ct"><span>Padecimientos</span></Link></li>
											<li><Link to="/contact-us"><span>Contacto</span></Link></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget">
										<h3 className="footer-title">Servicios</h3>
										<ul>
											<li><Link to="/service_ct"><span>Enfermedades Digestivas Quirúrgicas</span></Link></li>
											<li><Link to="/service_e"><span>Enfermedades Digestivas Médicas</span></Link></li>
											<li><Link to="/service_t"><span>Tratamiento Médico</span></Link></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_form">
										<h3 className="footer-title">Citas</h3>
										<div className="subscribe-form subscription-form mb-30">
										<li className="btn-area"><a href="/citas" className="btn btn-primary shadow">AGENDAR CITA<i className="btn-icon-bx fas fa-chevron-right"></i></a></li>
										</div>
										<div className="footer-social-link">
											<ul>
												<li><a target="_blank" rel="noreferrer" href="https://www.facebook.com/Gastrocirugiaags/"><img src={facebook} alt=""/></a></li>
												<li><a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/eduardo-javier-%C3%A1lvarez-del-castillo-s%C3%A1nchez-915288247/"><img src={linkedin} alt=""/></a></li>
											</ul>
										</div>
										<div className="subscribe-form subscription-form mb-30">
										<li className="btn-area">
											<a target="_blank" rel="noreferrer" href="https://digipris.cofepris.gob.mx/getTramite?id=2GuKHloI%2Fgd3bCJTkymjKQHBbQVBcNL5">
												<img className='mx-auto d-block cofepris' src={cofepris} alt=""/>
											</a>
										</li>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="container">
						<div className="footer-bottom">
							<div className="row">
								<div className="col-12 text-center">
									<p className="copyright-text">Copyright © 2025 Gastro Cirugia Aguascalientes</p>
								</div>
							</div>
						</div>
					</div>
					<img className="pt-img1 animate-wave" src={ptImg1} alt=""/>
					<img className="pt-img2 animate1" src={ptImg2} alt=""/>
					<img className="pt-img3 animate-rotate" src={ptImg3} alt=""/>
					<img className="pt-img4 animate-wave" src={ptImg4} alt=""/>
				</footer>
			
			</>
		);
	}
}

export default aboutSection;
